import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class Icon extends BaseOption {
  static userInterfaceComponent = {
    label: "Icon",
    component: inspectorTools.ICON_PICKER,
  };

  static defaultValue = "material-symbols:star-outline";
}
